import React from "react";
import Guess from './Guess';
import Result from './Result';
import EndPanel from './EndPanel';
import { AnimatePresence } from "framer-motion";

class SidePanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //count: 0,
      //process : "guess",
      //round: props.round,
    };
  }
  render() {
    return (
      <div
        className={`w-100 h-100 side-panel overflow-x-hidden overflow-y-auto-ns  
          ${
            this.props.process === "guess"
              ? "bg-custom-light"
              : "bg-custom-dark"
          } 
          ${
            this.props.process === "end"
              ? "overflow-y-auto"
              : "overflow-y-hidden"
          }
          `}
      >
      <AnimatePresence>
        {this.props.process === "guess" && (
          <Guess
            i18n = {this.props.i18n}
            openLink={this.props.openLink}
            gameData={this.props.gameData}
            round={this.props.round}
            mapsLoaded={this.props.mapsLoaded}
            registerCorrectPosition={this.props.registerCorrectPosition}
            displayMoreInfo={this.props.displayMoreInfo}
          />
        )}
        </AnimatePresence>
        <AnimatePresence>
        {this.props.process === "result" && (
          <Result
            i18n = {this.props.i18n}
            displayMoreInfo={this.props.displayMoreInfo}
            distance={this.props.distance}
            score={this.props.score}
            gameData={this.props.gameData}
            round={this.props.round}
            numRounds={this.props.numRounds}
            nextRound={this.props.nextRound}
          />
        )}
        </AnimatePresence>
        <AnimatePresence>
        {this.props.process === "end" && (
          <EndPanel
            i18n = {this.props.i18n}
            gameData={this.props.gameData}
            totalScore={this.props.totalScore}
            resetGame={this.props.resetGame}
            displayMoreInfo={this.props.displayMoreInfo}
            numRounds={this.props.numRounds}
            share={this.props.share}
          />
        ) }
        </AnimatePresence>
      </div>
    );
  }
}

export default SidePanel;



